import { RightOutlined } from '@ant-design/icons';
import { Waterbody, WaterbodyDetail } from '@omniafishing/core';
import { Divider } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiV1 } from '../../../../lib/api';
import { OmniaUrls } from '../../../../lib/urls';
import { WebAnalytics } from '../../../../lib/web_analytics';
import { useWaterbodyWebAnalyticsArgs } from '../../waterbody_detail_lib/use_waterbody_web_analytics_args';
import styles from './waterbody_detail_explore_nearby.less';
import { WaterbodyDetailWaterbodyCard } from './waterbody_detail_waterbody_card';

interface WaterbodyDetailExploreNearbyProps {
  slug: string;
  onLakeClick?: () => void;
  waterbody: WaterbodyDetail;
  linkToBoatRampsPage?: boolean;
}

const NUMBER_OF_WATERBODIES_TO_FETCH = 4;
const DEFAULT_NEARBY_DISTANCE = 50;

export const WaterbodyDetailExploreNearby = (props: WaterbodyDetailExploreNearbyProps) => {
  const { slug, onLakeClick, waterbody, linkToBoatRampsPage } = props;
  const [waterbodies, setWaterbodies] = useState([] as Waterbody[]);
  const { lat, lng, primary_name } = waterbody;
  const webAnalyticsLakeClickArgs = useWaterbodyWebAnalyticsArgs(waterbody);

  useEffect(() => {
    apiV1
      .waterbodiesNearbyFetch(slug, DEFAULT_NEARBY_DISTANCE, NUMBER_OF_WATERBODIES_TO_FETCH)
      .then((res) => {
        setWaterbodies(res.data.data);
      });
  }, []);

  return (
    <>
      {waterbodies.length > 0 && (
        <>
          <div className={styles.sectionHeader}>
            <h2>
              Explore <span>the {primary_name} Fishing Region</span>
            </h2>
          </div>
          <div>
            <ul className={styles.list}>
              {waterbodies.map((w) => {
                const distanceRounded = Number(
                  Math.round(Number(w.distance.toString() + 'e+1')) + 'e-1'
                );
                return (
                  <li className={styles.item} key={w.waterbody_id}>
                    <WaterbodyDetailWaterbodyCard
                      waterbody={w}
                      onClick={onLakeClick}
                      distance={distanceRounded}
                      linkToBoatRampsPage={linkToBoatRampsPage}
                    />
                  </li>
                );
              })}
            </ul>
            <Link
              to={OmniaUrls.map({ lat, lng })}
              className={styles.linkToMap}
              onClick={() =>
                WebAnalytics.lakePageClick('[nearby].(map_link)', webAnalyticsLakeClickArgs)
              }
            >
              <span>Explore more lakes near {primary_name}</span>
              <RightOutlined />
            </Link>
          </div>
          <Divider />
        </>
      )}
    </>
  );
};
